module.exports = __webpack_public_path__ + "static/media/20-iveco.2336390e.jpg";